const validator=require("validator");
module.exports = {
    setAppState: (data) => {
        localStorage.clear();
        localStorage.setItem("authenticated", true);
        localStorage.setItem('user', JSON.stringify(data.data))
        localStorage.setItem('token',validator.escape(data.token) )
        localStorage.setItem('refreshtoken', validator.escape(data.refresh_token))
        localStorage.setItem('user_type', data.data.role)
    }
}